<template>
    <TimelineItem class="c-task__timeline-item text-secondary">
        <Icon
            :custom="'icon icon-messages-bubble-quotation'"
            class="text-secondary"
            :size="16"
            slot="dot"
        />
        <div @mouseover="showDelete = true" @mouseleave="showDelete = false">
            <div class="mb-1">
                <div class="float-right">
                    <span v-show="!showDelete">{{ commentDateFormatted }}</span>
                    <Button
                        v-show="showDelete"
                        @click="handleDelete"
                        custom-icon="icon icon-close"
                        class="custom-ivu-btn-tiny"
                        :type="'text'"
                    />
                </div>
                <span class="text-dark font-weight-bold">{{
                    item.comment.created_by.first_name +
                        " " +
                        item.comment.created_by.last_name
                }}</span>
                said&hellip;
            </div>
            <div>
                <i>{{ item.comment.comment }}</i>
            </div>
        </div>
    </TimelineItem>
</template>

<script>
export default {
    props: {
        activity: Object, // parent
        item: Object, // data for the timeline event
    },
    data() {
        return {
            showDelete: false,
        };
    },
    computed: {
        commentDateFormatted: function() {
            return this.$moment(this.item.comment.created_at).fromNow();
        },
    },
    methods: {
        handleDelete() {
            this.$emit("delete", this.item);
        },
    },
};
</script>
